import React from "react";
import { useTranslation } from "react-i18next";

const Desc = ({ selectedPlugin }) => {
	const { i18n } = useTranslation();

	return (
		<section
			className="desc-wrap"
			dangerouslySetInnerHTML={
				i18n.language === "ko"
					? { __html: selectedPlugin.differentiation }
					: { __html: selectedPlugin.engDifferentiation }
			}
		></section>
	);
};

export default Desc;
